<template>
  <div class="recipes page">
  
    
    
    <transition-group
        enter-active-class="slideInRight"
        leave-active-class="slideOutLeft"
    >
      <RecipesSingle style="animation-duration: 0.5s" key="1" v-if="this.$route.query.recipe && !this.$route.query.seasonal"></RecipesSingle>
      <RecipesList style="animation-duration: 0.5s"  key="2" v-show="!this.$route.query.recipe" v-if="!this.$route.query.seasonal"></RecipesList>
      <SeasonalList style="animation-duration: 0.5s"  key="3" v-if="this.$route.query.seasonal && !this.$route.query.recipe"></SeasonalList>
    </transition-group>
    
  </div>
</template>

<script>
  
  import pageMixin from "../mixins/page";
  
  import RecipesList from "../components/RecipesList"
  import RecipesSingle from "../components/RecipesSingle"
  import SeasonalList from "../components/SeasonalList"

export default {
  name: 'Recipes',
  components: {RecipesList, RecipesSingle, SeasonalList},
  mixins: [pageMixin]
}
</script>

